export default __webpack_public_path__ + "static/media/002-waist.6453314a.svg";